import { useCallback } from "react";

import useParentLoaderData from "../../../../../hooks/useParentLoaderData";
import { useServicesStore } from "../store/services-provided/servicesStore";

import useFetchTabData from "./useFetchTabData";

export function useResetAllStores() {
  const { resetAll } = useServicesStore();
  const { id } = useParentLoaderData(2);
  const { refreshAvailableServices, refreshProvidedServices } = useFetchTabData({ id });

  const resetAllStores = useCallback(async () => {
    resetAll();

    await Promise.all([refreshAvailableServices(), refreshProvidedServices()]);
  }, [resetAll, refreshAvailableServices, refreshProvidedServices]);

  return { resetAllStores };
}
